import {
  OrganizationUserDTO,
  UserOrganizationStatus,
  UserOrganizationStatusMap,
  UserRolesMap,
  UserTypeMap,
} from '@markant-platform/shared/user/model';
import { HeaderAndTableCellDraft, SortAttributes } from '@markant-platform/shared/table/model';
import { UserType } from 'data-model';

export const ORGANIZATION_MEMBER_TABLE_CELLS: HeaderAndTableCellDraft[] = [
  {
    headerCellColumnId: 'salutation',
    headerCellTranslationKey: 'organization.users.salutation.label',
    tableCellContentKey: 'salutation',
    tableCellContentType: 'STRING',
    tableCellTranslationPrefix: 'organization.users.salutation',
    contentIsTranslationKey: true,
  },
  {
    headerCellColumnId: 'firstname',
    headerCellTranslationKey: 'organization.users.firstname',
    tableCellContentKey: 'firstname',
    tableCellContentType: 'CHIP_AND_STRING',
    additionalChip: {
      displayCondition: (user: unknown): boolean => {
        const orgUserDTO = user as OrganizationUserDTO;
        return orgUserDTO.userType === UserType.TECHNICAL;
      },
      tableCellContentKey: 'userType',
      tableCellTranslationPrefix: 'organization.users.type.chip',
      chipConfigMap: UserTypeMap,
    },
  },
  {
    headerCellColumnId: 'lastname',
    headerCellTranslationKey: 'organization.users.lastname',
    tableCellContentKey: 'lastname',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'language',
    headerCellTranslationKey: 'organization.users.language',
    tableCellContentKey: 'language',
    tableCellContentType: 'STRING',
    tableCellTranslationPrefix: 'languageSelect',
  },
  {
    headerCellColumnId: 'email',
    headerCellTranslationKey: 'organization.users.email',
    tableCellContentKey: 'email',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'role',
    headerCellTranslationKey: 'organization.users.role',
    tableCellContentKey: 'platformRoles',
    tableCellContentType: 'CHIP',
    tableCellTranslationPrefix: 'common.platformRoles.short',
    chipConfigMap: UserRolesMap,
  },
  {
    headerCellColumnId: 'status',
    headerCellTranslationKey: 'organization.users.status.label',
    tableCellContentKey: 'userOrganizationStatus',
    tableCellContentType: 'CHIP',
    tableCellTranslationPrefix: 'organization.users.status',
    chipConfigMap: UserOrganizationStatusMap,
  },
  {
    headerCellColumnId: 'becameActiveAt',
    headerCellTranslationKey: 'organization.users.activationDate',
    tableCellContentKey: 'becameActiveAt',
    tableCellContentType: 'DATE',
  },
  {
    headerCellColumnId: 'phone',
    headerCellTranslationKey: 'organization.users.phone',
    tableCellContentKey: 'phone',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'country',
    headerCellTranslationKey: 'organization.users.country',
    tableCellContentKey: 'address.countryCode',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'department',
    headerCellTranslationKey: 'organization.users.department',
    tableCellContentKey: 'department',
    tableCellContentType: 'STRING',
    tableCellTranslationPrefix: 'register.user.departmentOptions',
  },
  {
    headerCellColumnId: 'streetNumber',
    headerCellTranslationKey: 'organization.users.streetNumber',
    tableCellContentKey: 'address.streetNumber',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'position',
    headerCellTranslationKey: 'organization.users.position',
    tableCellContentKey: 'position',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'createdAt',
    headerCellTranslationKey: 'organization.users.registeredBy',
    tableCellContentKey: 'createdAt',
    tableCellContentType: 'DATE',
  },
  {
    headerCellColumnId: 'street',
    headerCellTranslationKey: 'organization.users.street',
    tableCellContentKey: 'address.street',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'city',
    headerCellTranslationKey: 'organization.users.city',
    tableCellContentKey: 'address.city',
    tableCellContentType: 'STRING',
  },
];

export const DEFAULT_FILTER = { state: [UserOrganizationStatus.ACTIVE, UserOrganizationStatus.INVITED] };
export const DEFAULT_SORT: SortAttributes = { sortOrder: 'asc', sortField: 'lastname' };

export const DEFAULT_HIDDEN_COLUMNS = [
  'becameActiveAt',
  'phone',
  'country',
  'department',
  'streetNumber',
  'position',
  'createdAt',
  'street',
  'city',
];
